export default __webpack_public_path__ + "static/media/wahlheymat.bf2c4908.png";